import React, { Component, Fragment } from 'react';
import { Row, Col, Container, Jumbotron, Card } from 'react-bootstrap';
import HeaderMenu from './menu/header_container';
import MenuClientes from './menu_clientes';

// import Menu from './menu';
// import config from '../config';
// //import Menu from './menu';
// import CardPrincipalReport from './subcomponent/cardPrincipalReport';

class Home extends Component {
  tipo = sessionStorage.getItem('tipo');
  company = sessionStorage.getItem('company');
  componentDidMount() { }
  //className={'disabled-card'
  redirect = (url) => {
    location.href = '/' + url;
  }
  render() {
    return (
      <Fragment>
        {(this.tipo === 'C' || (this.tipo === '3' && this.company === '900130488'))
          ? <MenuClientes></MenuClientes>
          : <Fragment>
            <HeaderMenu></HeaderMenu>
            <Jumbotron className="Jumbotron">
              <h2 className="m-3">GESTIONAR BUSSINES</h2>
            </Jumbotron>
            <Container>
              <Row>
                <Col>
                  <Card bg='light'  >
                    <Card.Body onClick={() => this.redirect('ventas')} >
                      <Row>
                        <Col><img src='/sell.png' alt='' /></Col>
                        <Col className='text-center my-auto' >VENTAS</Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card bg='light'>
                    <Card.Body onClick={() => this.redirect('edoc')}><Row>
                      <Col><img src='/invoice_ele.png' alt='' /></Col>
                      <Col className='text-center my-auto' >GESTION DOCUMENTOS ELECTRONICOS</Col>
                    </Row></Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card bg='light'>
                    <Card.Body onClick={() => this.redirect('pos')}><Row>
                      <Col><img src='/pos.png' alt='' /></Col>
                      <Col className='text-center my-auto' >POS</Col>
                    </Row></Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Card bg='light'>
                    <Card.Body onClick={() => this.redirect('payroll')}><Row>
                      <Col><img src='/payroll.png' alt='' /></Col>
                      <Col className='text-center my-auto' >NOMINA</Col>
                    </Row></Card.Body>
                  </Card>
                </Col>

                <Col>
                  <Card bg='light'>
                    <Card.Body onClick={() => this.redirect('inventary')}><Row>
                      <Col><img src='/delivery.png' alt='' /></Col>
                      <Col className='text-center my-auto' >INVENTARIO</Col>
                    </Row></Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card bg='light'>
                    <Card.Body onClick={() => this.redirect('catalog')}><Row>
                      <Col><img src='/catalog.png' alt='' /></Col>
                      <Col className='text-center my-auto' >CATALOGOS</Col>
                    </Row></Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Card bg='light'>
                    <Card.Body onClick={() => this.redirect('configuration')}><Row>
                      <Col><img src='/config_2.png' alt='' /></Col>
                      <Col className='text-center my-auto' >CONFIGURACIONES</Col>
                    </Row></Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card bg='light'>
                    <Card.Body onClick={() => this.redirect('batch')}><Row>
                      <Col><img src='/new_upload.png' alt='' height={62} /></Col>
                      <Col className='text-center my-auto' >PROCESOS BATCH</Col>
                    </Row></Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </Fragment>
        }

      </Fragment>
    );
  }
}
export default (Home);


// WEBPACK FOOTER //
// ./src/components/home.jsx